export * from './registration-page.component';
